"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroStittsville() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262889" id="hero-stittsville" className="bg-background text-foreground py-20 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/10 blur-[120px] rounded-lg pointer-events-none" />

      <div className="page-container relative z-10">
        <div ref={headerRef} className={`max-w-4xl mx-auto text-center flex flex-col items-center gap-6 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="secondary" className="gap-2 py-1.5 px-4 rounded-lg text-sm bg-secondary/20 text-primary border-secondary/30">
            <Sparkles className="size-4 text-primary" />
            <span className="font-default font-semibold">Same Day Pickups Available</span>
          </Badge>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold font-default tracking-tight text-foreground">
            Junk Removal Stittsville
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-2xl leading-relaxed">
            Fast affordable junk removal in Stittsville with same day pickups available for furniture, appliances, renovation debris, mattresses, and household junk.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mt-6 w-full sm:w-auto">
            <Button size="lg" asChild className="rounded-lg w-full sm:w-auto text-base h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
              <Link to="/PricingPage">
                Get a Free Quote
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button size="lg" variant="secondary" asChild className="rounded-lg w-full sm:w-auto text-base h-12 px-8 bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-md">
              <Link to="#">
                Text Us Photos
              </Link>
            </Button>
          </div>
        </div>

        <div ref={imageRef} className={`mt-16 lg:mt-24 transition-all duration-1000 delay-200 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
          <div className="rounded-xl border border-border/50 bg-card/50 p-2 md:p-4 shadow-2xl backdrop-blur-sm">
            <div className="rounded-lg overflow-hidden border border-border bg-background shadow-inner">
              <AspectRatio ratio={16 / 9}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/stittsville_junk_removal_team.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/stittsville_junk_removal_team.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/stittsville_junk_removal_team.png-wvc-sizes" alt="Two professional junk removal workers in black polos and khaki pants carrying furniture near a branded removal truck" className="w-full h-full object-cover" loading="lazy" decoding="async" />
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}